const BaseUrl = "https://fruitables-7yyj.onrender.com/api/v1";

export default BaseUrl;